import React from 'react'
import Preloader from '../../Global/Preloader';
import Headerthree from '../Mainhomethree/Headerthree';
import Bannerthree from '../Mainhomethree/Bannerthree';
import Abouttwo from '../Mainhomethree/Abouttwo';
import Whychoosethree from '../Mainhomethree/Whychoosethree';
import Servicesthree from '../Mainhomethree/Servicesthree';
import Processsecond from '../Mainhomethree/Processsecond';
import Benefitsone from '../Mainhomethree/Banefitsone';
import Aboutthree from '../Mainhomethree/Aboutthree';
import Testimonialthree from '../Mainhomethree/Testimonialthree';
import Blogthree from '../Mainhomethree/Blogthree';
import Ctathree from '../Mainhomethree/Ctathree';
import Faqone from '../Mainhomethree/Faqone';
import Footertwo from '../../Global/Footertwo';
import BackToTop from '../../Global/BackToTop';

const Main = () => {
    return (
        <>
        <Preloader/>
        <Headerthree/>
        <Bannerthree/>
        <Abouttwo/>
        <Whychoosethree/>
        <Servicesthree/>
        <Processsecond/>
        <Benefitsone/>
        <Aboutthree/>
        <Testimonialthree/>
        <Blogthree/>
        <Ctathree/>
        <Faqone/>
        <Footertwo/>
        <BackToTop/>
        </>
    )
}
export default Main;